import { Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { isNil } from 'lodash-es';
import {
  distinctUntilChanged,
  filter,
  fromEvent,
  map,
  skip,
  switchMap,
  tap,
} from 'rxjs';
import { UserService } from '@ipg/ngx-frontend-toolset';
import { User } from './models/user.model';
import { UnitService } from './views/units/services/unit.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'app';

  private readonly userService = inject<UserService<User>>(UserService);
  private readonly unitService = inject(UnitService);
  private readonly router = inject(Router);

  private readonly user$ = toObservable(this.userService.data).pipe(
    filter((data) => !isNil(data))
  );

  private readonly currentUnitId$ = this.user$.pipe(
    map((user) => user.unitId),
    distinctUntilChanged()
  );

  constructor() {
    this.currentUnitId$
      .pipe(
        switchMap(() => this.unitService.getCurrent()),
        skip(1),
        tap(() => this.router.navigate(['/clients']))
      )
      .subscribe();

    fromEvent(document, 'visibilitychange')
      .pipe(
        filter(() => document.visibilityState === 'visible'),
        switchMap(() => this.userService.fetch())
      )
      .subscribe();
  }
}

